"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskStateTransitionDTO = void 0;
class TaskStateTransitionDTO {
}
exports.TaskStateTransitionDTO = TaskStateTransitionDTO;
